/**
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */
'use strict';

var React = require('react');

module.exports = {
    executeAction: React.PropTypes.func.isRequired,
    getStore: React.PropTypes.func.isRequired
};



/*****************
 ** WEBPACK FOOTER
 ** ./~/fluxible/lib/contextTypes.js
 ** module id = 237
 ** module chunks = 0
 **/